import React from 'react';

export type SSRData = {
  products?: Record<string, any>;
  [key: string]: any;
}

export const SSRDataContext = React.createContext<SSRData | null>(null);

export const SSRDataProvider: React.FC<React.PropsWithChildren<{ data: SSRData | null }>> = ({ data, children }) => {
  return (
    <SSRDataContext.Provider value={data}>
      {children}
    </SSRDataContext.Provider>
  );
};

export default SSRDataContext;
